export const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate())

export const endOfDay = (date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999)

export const startOfWeek = (date) => {
  const day = date.getDay()
  const diff = date.getDate() - day
  return new Date(date.getFullYear(), date.getMonth(), diff)
}

export const endOfWeek = (date) => {
  const start = startOfWeek(date)
  return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6, 23, 59, 59, 999)
}

export const startOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1)

export const endOfMonth = (date) =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)

export const startOfYear = (date) => new Date(date.getFullYear(), 0, 1)

export const endOfYear = (date) => new Date(date.getFullYear(), 11, 31, 23, 59, 59, 999)

export const subtractDays = (baseDate, days) =>
  new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate() - days)
